import React from "react"

export function FloatingActionsPlacement() {
  return <div id="FLOATING_ITEMS_PLACEMENT" />
}

import ReactDOM from "react-dom"

export function FloatingActions({ children }: { children: React.ReactNode }) {
  const container = document.getElementById("FLOATING_ITEMS_PLACEMENT")

  if (!container) {
    return null
  }

  return ReactDOM.createPortal(<div>{children}</div>, container)
}
